import { databasesStardogRequestDispatchers } from 'src/actions/databases/actionCreators';
import { DatabasesActionType } from 'src/actions/databases/actionTypes';
import { PublishProjectResponse } from 'src/actions/projects/actionCreators';
import { DatabaseProperty } from 'src/constants/databaseProperties';
import { PrefixInfo } from 'src/containers/PublishProjectDrawer/types';
import { Database } from 'src/store/state/databases';
import * as copy from 'src/templates/copy';

const formatNamespaces = (namespaces: Record<string, string>) => {
  return Object.entries(namespaces).map(
    ([prefix, namespace]) => `${prefix}=${namespace}`
  );
};

export const publishDatabaseNamespaces = async (
  database: Database,
  prefixInfoArr: PrefixInfo[],
  isNewDatabase: boolean
): Promise<PublishProjectResponse | null> => {
  const filteredPrefixInfoArr = prefixInfoArr.filter(
    ({ shouldPublish }) => shouldPublish
  );
  if (!filteredPrefixInfoArr.length || !database) {
    return null;
  }

  const namespacesToUpdate = prefixInfoArr.reduce<Record<string, string>>(
    (acc, prefixInfo) => {
      if (prefixInfo.shouldPublish) {
        acc[prefixInfo.prefix] = prefixInfo.namespace;
      }
      return acc;
    },
    {}
  );

  const existingNamespaces = database.namespaces ?? {};
  const allNamespaces = isNewDatabase
    ? { ...existingNamespaces, ...namespacesToUpdate }
    : { ...namespacesToUpdate, ...existingNamespaces };

  const updateDbDetailsResponse =
    await databasesStardogRequestDispatchers.updateDatabaseDetails(
      database.id,
      {
        [DatabaseProperty.DATABASE_NAMESPACES]: formatNamespaces(allNamespaces),
      }
    );

  if (
    updateDbDetailsResponse.type ===
    DatabasesActionType.UPDATE_DATABASE_DETAILS_FAILURE
  ) {
    return {
      success: false,
      action: updateDbDetailsResponse,
      actionDescription: copy.notifications.database.publishDatabaseNamespaces,
      message: copy.notifications.publishProject.databaseNamespaces.failure,
    };
  }

  return {
    success: true,
    action: updateDbDetailsResponse,
    message: copy.notifications.publishProject.databaseNamespaces.success,
  };
};
